import FiltersItem        from "../Entities/FiltersItem";
import FiltersData        from '../Entities/FiltersData';
import HTTPResponseEntity from '@/js/Shared/Services/HTTP/Entities/HTTPResponseEntity.js';


export { FiltersHTTPMappings as default };

/**
* Filters Mappings
*
* Maps filters data from any source to the corresponding entities
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class FiltersHTTPMappings {
  /**
   * Maps the server filter results list into a new filter data entity
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {FiltersData}        data     filters data
   * @param {HTTPResponseEntity} response server response
   *
   * @return {void}
   */
   mapResults(data, response) {
    if (response.results.metadata) {
      this.mapResultsMetadata(data, response.results.metadata);
      this.mapResultsList(data, response.results.list);
      data.filters.resortItems();
      return;
    }

    if (response.results.filters.add) {
      this.mapResultsAdd(data, response.results.filters.add);
    }

    if (response.results.filters.update) {
      this.mapResultsUpdate(data, response.results.filters.update);
    }

    if (response.results.filters.delete) {
      this.mapResultsDelete(data, response.results.filters.delete);
    }

    data.filters.resortItems()
  }

  /**
   * Maps server metadata endpoint results into filters metatada entity
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {FiltersData} data    filters data
   * @param {Object}      results server results
   *
   * @return {void}
   */
  mapResultsMetadata(data, results) {
    data.metadata.conditions = results.conditions;
    data.metadata.flags      = results.flags;
    data.metadata.actions    = results.actions;
    data.metadata.combine    = results.combine;
  }

  /**
   * Maps server list endpoint results into filters list entity
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {FiltersData} data    filters data
   * @param {Object}      results server results
   *
   * @return {void}
   */
  mapResultsList(data, results) {
    results.forEach((item) => {
      data.filters.add(
        this.mapFiltersItem(item)
      );
    })
  }

  /**
   * Maps the server filters results and adds it to the given filter data entity
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {FiltersData} data    filters data
   * @param {Object}      results server results
   *
   * @return {void}
   */
  mapResultsAdd(data, results) {
    results.forEach((item) => {
      data.filters.add(
        this.mapFiltersItem(item)
      );
    })
  }

  /**
   * Maps the server filters results and update the filter by the given filter
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {FiltersData} data    filters data
   * @param {Object}      results server results
   *
   * @return {void}
   */
  mapResultsUpdate(data, results) {
    results.forEach((item) => {
      data.filters.update(
        this.mapFiltersItem(item)
      );
    })
  }

  /**
   * Removes all deleted filters from filter list
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {FiltersData} data    filters data
   * @param {Object}      results server results
   *
   * @return {void}
   */
  mapResultsDelete(data, results) {
    results.forEach((id) => {
      data.filters.delete(id);
    })
  }

  /**
   * Maps filter item server data into a filter item entity entity
   *
   * @private
   *
   * @since 7.0.0
   *
   * @param {FiltersListEntity} filters        filters list
   * @param {Object}            server_results server results
   *
   * @return {NewsletterSubscriptionEntity}
   */
  mapFiltersItem(data) {
    let item          = new FiltersItem();
    item.id           = data.uid     || 0;
    item.name         = data.name    || '';
    item.combine      = data.combine || 0;
    item.action       = data.action  || '';
    item.enabled      = data.disable === true ? false : true;
    item.action_value = data.value;
    item.conditions   = [];
    item.flags        = {};

    if (data.flags) {
      item.flags = data.flags;
    }

    data.conditions.forEach(server_condition => {
      let condition   = item.createCondition();
      condition.field = server_condition.field || '';
      condition.test  = server_condition.match || '';
      condition.type  = server_condition.type  || 0;
      condition.value = server_condition.value || '';
    });

    return item;
  }
}